import {ReactNode, useState} from "react"
import {ToastContext, ToastMap} from "@/library/toasts/toast-context"
import {ToastProps} from "@/components/ui-kit/toast"

const ToastProvider = ({children}: { children?: ReactNode }) => {
    const [toasts, setToasts] = useState<ToastMap>({})

    const toast = (key: string, options: Omit<ToastProps, 'refKey' | 'removed'>) => {
        if (options.autoClose !== false) {
            setTimeout(() => {
                closeToast(key)
            }, options.autoCloseDelay ?? 2_000)
        }

        setToasts(current => {

            return {
                ...current,
                ...{
                    [key]: {
                        ...options,
                        refKey: key,
                        removed: false
                    }
                }
            }
        })
    }

    const clear = async () => {
        setToasts(current => {
            Object.keys(current).forEach(key => {
                current[key].removed = true
            })

            return current
        })
    }

    const closeToast = (key: string) => {
        setToasts(current => {
            const currentKey = current[key]

            return {
                ...current,
                [key]: {
                    ...currentKey,
                    removed: true
                }
            }
        })
    }

    return <ToastContext.Provider value={{
        toasts: toasts,
        toast: toast,
        closeToast: closeToast,
        clear: clear,
    }}>{children}</ToastContext.Provider>
}

export default ToastProvider
